import { about } from '../data/site'
import Reveal from './Reveal'
import AboutIllustration from './illustrations/AboutIllustration'

export default function About() {
  return (
    <section id="about" className="bg-slate-50 py-24">
      <div className="mx-auto grid max-w-6xl items-center gap-14 px-6 lg:grid-cols-2">
        {/* illustration */}
        <Reveal className="order-last lg:order-first">
          <AboutIllustration className="mx-auto w-full max-w-md" />
        </Reveal>

        {/* copy */}
        <div>
          <Reveal>
            <span className="text-sm font-semibold uppercase tracking-wider text-brand-600">
              {about.eyebrow}
            </span>
            <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              {about.title}
            </h2>
            {about.paragraphs.map((p) => (
              <p key={p} className="mt-4 text-lg leading-relaxed text-slate-500">
                {p}
              </p>
            ))}
          </Reveal>

          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2">
            {about.pillars.map((pillar, i) => {
              const Icon = pillar.icon
              return (
                <Reveal
                  key={pillar.title}
                  delay={(i % 2) * 90}
                  className="flex gap-4 rounded-xl border border-slate-100 bg-white p-5 shadow-[var(--shadow-soft)]"
                >
                  <div className="grid h-10 w-10 shrink-0 place-items-center rounded-lg bg-brand-50 text-brand-600">
                    <Icon className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900">{pillar.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-slate-500">
                      {pillar.description}
                    </p>
                  </div>
                </Reveal>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}
